import React from 'react';
import Select from 'react-select';
import ToggleSelect from './ToggleSelect.js';

import './RecommendedTypeSelector.css';
import { getTranslation } from '../../../../assets/creator/translations.js';

const recTypeSelectStyles = {
    control: () => ({
        // border: '1px solid #f00',
        display: 'none',
        lineHeight: '27px',
        width: '100%',
    }),
    indicatorSeparator: (base) => ({
        ...base,
        height: '80%',
        margin: '0',
    }),
    valueContainer: () => ({
        width: '90%',
    }),
    menuList: (base) => ({
        ...base,
        maxHeight: '230px',
        overflowY: 'auto',
    }),
    menu: (base) => ({
        ...base,
        marginTop: '0',
        boxShadow: "8px 8px 18px -2px #42445a",
        zIndex: "2",
    }),
    dropdownIndicator: (base) => ({
        ...base,
        paddingRight: '0',
    }),
    option: (base, state) => ({
        ...base,
        ...(state.isFocused && { backgroundColor: '#e3e3fa' }),
        cursor: "pointer",
        height: "32px",
        display: "flex",
        alignItems: "center",
        padding: "3px 12px",
        ':active': {
            ...base[':active'],
            backgroundColor: '#C8C8FA'
        }
    }),
};

const RecTypeSelect = (props) => {
    const recTypeOptions = require('../../../../assets/liquidSettingsTypes/recommendedType.json');
    recTypeOptions.forEach(element => {
        element.label = getTranslation(element.translationKey);
    });

    return (
        <Select
            ref={props.refSelect}
            onChange={props.recommendedTypeChangeHandler}
            options={recTypeOptions}
            value={recTypeOptions[props.recommendedTypeCurrent - 1]}
            hideSelectedOptions={true}
            menuShouldScrollIntoView={false}
            classNamePrefix="rec-type"
            className="rec-type-container"
            styles={recTypeSelectStyles}
        />);
};
const RecommendedTypeSelector = (props) => {
    if (props.type !== "newsSection") {
        return null;
    }

    const refToSelect = React.createRef();
    const recTypeOptions = require('../../../../assets/liquidSettingsTypes/recommendedType.json');
    const currentOption = recTypeOptions[props.recommendedTypeCurrent - 1];
    
    return (
        <React.Fragment>
            <div className="recommended-type-selector">
            <ToggleSelect
                    closeMenuOnSelect={true}
                    selectRef={refToSelect}
                    isOpen={false}
                    isFrom={props.isFrom}
                    iconClassName={"recommended-type-selector__select-toggle-icon"}
                    className="recommended-type-selector__select-toggle"
                >
                    {getTranslation("ChangeType")}
                </ToggleSelect>
                <span className="recommended-type-selector__current-type">
                    {/* {getTranslation("Type")}:  */}
                    {getTranslation(currentOption.translationKey)}
                </span>

            </div>
            <RecTypeSelect refSelect={refToSelect} {...props} />
        </React.Fragment>
    );
};

export default RecommendedTypeSelector;